import { t } from "i18next";
import { useState } from "react";
import DepartmentAssociationModal from "./DepartmentAssociationModal";

const DepartmentCell = ({ row, departments }) => {
  const [open, setOpen] = useState(false);

  const departmentCount = row.departments ? row.departments.length : 0;

  return row.roleId !== "ac" ? (
    <>
      <div
        onClick={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") setOpen(true);
        }}
        tabIndex={0}
        style={{
          height: "100%",
          outline: "none",
          display: "flex",
          alignItems: "center",
        }}
      >
        <p>
          {departmentCount}{" "}
          {departmentCount === 1
            ? t("academicHierarchy.department")
            : t("assessment.departments")}
        </p>
      </div>
      <DepartmentAssociationModal
        open={open}
        setOpen={setOpen}
        departments={departments}
        userInfo={row}
      />
    </>
  ) : (
    <p>{t("user.notApplicable")}</p>
  );
};

export default DepartmentCell;
